export interface PersonModel {
  id: number
  firstName: string
  familyName: string
}

export default class Person implements PersonModel{
  private constructor (
    readonly id: number,
    readonly firstName: string,
    readonly familyName: string,
  ) {
  }

  get fullName (): string {
    return `${this.firstName} ${this.familyName}`
  }

  public static createFromModel (data: Partial<PersonModel>): Person {
    return new Person(
      data.id!,
      data.firstName!,
      data.familyName!
    );
  }
}